module.exports = __webpack_public_path__ + "img/right-bg.bfb7b5ea.png";